import React from 'react';
import { useEffect } from 'react';
import '../../../cssFiles/thankyouPages.scss';
import Header from '../../layouts/header'; 
import Footer from '../../layouts/footer';
import Celebration from '../../layouts/celebration';
import { useLocation } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';


const PremiumThankyou = () => {
    const location = useLocation();
    const navigate = useNavigate();

    useEffect(() => {
        if (location.state && location.state.product === 'premium') {
            document.title = "Niveza - Thank You";
            window.scrollTo(0, 0);
        }else {
            navigate('/products/premium')
        }
    }, [location.state, navigate]);

    const backToProductPage = () => {
        navigate('/products/premium');
    }


    
    return (
        <div className="thankyou-page-container">
            <Header />
            <Celebration />
            <div className="thankyou-image-section">
                <div className="thankyou-content">
                    <h1 className='thankyou-header'>Thank You for Connecting with Us!!</h1>
                    <p>We truly appreciate your interest in our Portfolio Management Services (PMS). Your details have been received, and one of our investment specialists will get in touch with you shortly to help you make the most of your wealth.</p>
                </div>

                <div className="thankyou-content">
                    <h1 className='thankyou-header'>What is PMS and Why It Matters for You</h1>
                    <p>Portfolio Management Services (PMS) are professionally managed investment portfolios designed to help you grow, preserve, and optimize your wealth. Unlike mutual funds, PMS offers a personalized investment approach — tailored to your financial goals, risk appetite, and long-term vision.</p>
                    <p>With PMS, your portfolio isn’t just another number in the system — it’s a custom-crafted strategy managed by experts who actively monitor, rebalance, and align your investments with market opportunities.</p>
                </div>

                <div className="thankyou-content">
                    <h1 className='thankyou-header'>Why Investors Choose Our PMS</h1>
                    <p>We understand that your wealth deserves more than standard solutions. Here’s what makes our PMS unique:</p>
                    <ul>
                        <li><strong>Personalized Strategies:</strong> Every investor is unique, and so are our investment strategies. We tailor portfolios to your specific financial goals and risk tolerance.</li>
                        <li><strong>Expert Management:</strong> Our team of seasoned investment professionals actively manages your portfolio, ensuring it adapts to market changes and opportunities.</li>
                        <li><strong>Transparency & Reporting:</strong> Stay informed with regular updates, performance reports, and insights into your portfolio’s progress.</li>
                        <li><strong>Dedicated Support:</strong> Our relationship managers are always available to address your queries and provide guidance.</li>
                        <li><strong>Data-Driven Decisions::</strong> Our analysts use cutting-edge market research and AI-assisted models to find the right opportunities at the right time.</li>
                        <li><strong>Transparent & Accountable:</strong> You stay updated on every trade and performance metric — no hidden surprises.</li>
                    </ul>
                </div>

                <div className="thankyou-content">
                    <h1 className='thankyou-header'>What Happens Next</h1>
                    <p>Our team will contact you soon to understand your investment goals and guide you through the next steps.
                    Until then, we encourage you to explore more about our PMS strategies, market insights, and client success stories.</p>
                </div>

                {/* <div className='thankyou-header'>Stay informed. Stay ahead. Let’s grow together.</div> */}

                <div className="thankyou-content">
                    <p>We’re excited to be part of your investment journey. Together, let’s create a future where your money works harder — and smarter — for you.</p>
                    <h1 className='thankyou-header'>Once Again, Thank You!</h1>
                </div>

                <div style={{textAlign:'center'}}>
                    <button className='thankyou-back-button' onClick={backToProductPage}>Back to product page</button>
                </div>
            </div>
            <Footer />
        </div>
    );
};
export default PremiumThankyou;